import { render } from "./ArgonTextarea.vue?vue&type=template&id=6d10023b&scoped=true"
import script from "./ArgonTextarea.vue?vue&type=script&lang=js"
export * from "./ArgonTextarea.vue?vue&type=script&lang=js"

import "./ArgonTextarea.vue?vue&type=style&index=0&id=6d10023b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d10023b"]])

export default __exports__